define [], () ->
  (RentappService, $cookies) ->
    template: require("./integrations.jade")
    link: (scope, element, attrs) ->
      RentappService.getMe().then (user) ->



// WEBPACK FOOTER //
// ./directives/integrations/integrations.coffee